"use strict";
/*
 * Created on 03.05.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Tomas Leity
 */


var WindowItemHistoryTableConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemHistoryTableConverter, _DataObjectConverter_);

  function WindowItemHistoryTableConverter() {
    _classCallCheck(this, WindowItemHistoryTableConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemHistoryTableConverter).apply(this, arguments));
  }

  return WindowItemHistoryTableConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemHistoryTableConverter = WindowItemHistoryTableConverter;